import { useState, useCallback } from 'react';
import { supabase } from '../integrations/supabase/client';

export interface AdminUser {
  id: string;
  email: string | undefined;
  created_at: string;
  last_sign_in_at: string | undefined;
  company_name: string | null;
  onboarding_completed: boolean;
  plan: string;
  status: string;
}

export function useAdminClients() {
  const [clients, setClients] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: fnError } = await supabase.functions.invoke('admin-list-users');
      if (fnError) throw fnError;
      if (data?.error) throw new Error(data.error);
      setClients(data?.users ?? []);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Erro ao carregar usuários';
      setError(message);
      setClients([]);
      console.error('[useAdminClients]', err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { clients, loading, error, fetchClients };
}
